'use client';

import { fetcher } from '@insta-club/api';
import type { FirebaseOptions } from 'firebase/app';

const firebaseConfig: FirebaseOptions = {
    apiKey: 'AIzaSyAjyN99Y5KoldWKiSVMHmBoRkvwYnz7iOE',
    authDomain: 'insta-club-3a054.firebaseapp.com',
    projectId: 'insta-club-3a054',
    storageBucket: 'insta-club-3a054.firebasestorage.app',
    messagingSenderId: '972899114841',
    appId: '1:972899114841:web:9e6ac276723fd7e3167648',
    measurementId: 'G-K6LVH2Q3W3'
};

const vapidKey: string | undefined = process.env.NEXT_PUBLIC_VAPIDKEY;

export async function initWebPushNotifications(): Promise<void> {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) {
        throw new Error('Browser does not support Notifications or Service Workers.');
    }
    if (Notification.permission !== 'granted') {
        const perm = await Notification.requestPermission();
        if (perm !== 'granted') {
            throw new Error('Notifications permission was denied.');
        }
    }

    const { initializeApp } = await import('firebase/app');
    const { getMessaging, getToken, onMessage, isSupported } = await import('firebase/messaging');

    if (!(await isSupported())) {
        throw new Error('FCM not supported in this browser.');
    }

    const app = initializeApp(firebaseConfig);
    const messaging = getMessaging(app);

    onMessage(messaging, (payload) => {
        console.log('Message received:', payload);
    });

    const registration = await registerServiceWorker('/firebase-messaging-sw.js');
    await waitForActivation(registration);

    let token: string;

    try {
        token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: registration });
        if (!token) throw new Error('FCM returned no token — maybe the user has blocked notifications.');
    } catch (initialErr) {
        token = await getToken(messaging, { vapidKey, serviceWorkerRegistration: registration });
        if (!token) throw initialErr;
    }

    await sendTokenToServer(token);
}

async function registerServiceWorker(scriptURL: string): Promise<ServiceWorkerRegistration> {
    return await navigator.serviceWorker.register(scriptURL);
}

function waitForActivation(reg: ServiceWorkerRegistration): Promise<void> {
    const sw = reg.installing || reg.waiting;
    if (reg.active && !sw) return Promise.resolve();

    return new Promise<void>((resolve, reject) => {
        if (!sw) {
            return navigator.serviceWorker.ready.then(() => resolve()).catch(reject);
        }

        const onStateChange = (evt: Event): void => {
            const target = evt?.target as ServiceWorker | null;
            if (target?.state === 'activated') {
                sw.removeEventListener('statechange', onStateChange);
                resolve();
            }
        };

        sw.addEventListener('statechange', onStateChange);
    });
}

async function sendTokenToServer(fcm_token: string): Promise<void> {
    try {
        await fetcher('/fcm', 'dashboard', 'GET', {
            params: {
                fcm_token
            }
        });
    } catch (error) {
        console.log('Error sending FCM token:', error);
    }
}

